var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 3.39998C2.33538 3.39998 2.06675 3.66861 2.06675 3.99998C2.06675 4.33135 2.33538 4.59998 2.66675 4.59998V3.39998ZM13.3334 4.59998C13.6648 4.59998 13.9334 4.33135 13.9334 3.99998C13.9334 3.66861 13.6648 3.39998 13.3334 3.39998V4.59998ZM4.73341 3.99998C4.73341 4.33135 5.00204 4.59998 5.33341 4.59998C5.66479 4.59998 5.93341 4.33135 5.93341 3.99998H4.73341ZM10.0667 3.99998C10.0667 4.33135 10.3354 4.59998 10.6667 4.59998C10.9981 4.59998 11.2667 4.33135 11.2667 3.99998H10.0667ZM12.0668 3.99462L12.0069 10.697L13.2069 10.7077L13.2667 4.00534L12.0668 3.99462ZM8.60706 14.0666H7.33341V15.2666H8.60706V14.0666ZM2.73341 3.99998V10.6666H3.93341V3.99998H2.73341ZM2.66675 4.59998H3.33341V3.39998H2.66675V4.59998ZM3.33341 4.59998H12.6667V3.39998H3.33341V4.59998ZM12.6667 4.59998H13.3334V3.39998H12.6667V4.59998ZM5.93341 3.70368C5.93341 2.79042 6.7903 1.93331 8.00008 1.93331V0.733313C6.26434 0.733313 4.73341 1.99871 4.73341 3.70368H5.93341ZM8.00008 1.93331C9.20986 1.93331 10.0667 2.79042 10.0667 3.70368H11.2667C11.2667 1.99871 9.73582 0.733313 8.00008 0.733313V1.93331ZM4.73341 3.70368V3.99998H5.93341V3.70368H4.73341ZM10.0667 3.70368V3.99998H11.2667V3.70368H10.0667ZM7.33341 14.0666C5.45565 14.0666 3.93341 12.5444 3.93341 10.6666H2.73341C2.73341 13.2072 4.7929 15.2666 7.33341 15.2666V14.0666ZM12.0069 10.697C11.9903 12.5629 10.473 14.0666 8.60706 14.0666V15.2666C11.1316 15.2666 13.1843 13.2321 13.2069 10.7077L12.0069 10.697Z",
    fill: "url(#paint0_linear_8387_6195)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8387_6195",
    x1: -3.39992,
    y1: -6.08335,
    x2: 16.8079,
    y2: 9.37444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#299FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0202A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGradient);
export default __webpack_public_path__ + "static/media/trash-gradient.1cbb2acb85508c5216583ddd7ed95caa.svg";
export { ForwardRef as ReactComponent };